<div class="pos-panel">
    <div class="pos-panel-header">
        <span class="soc-panel-header">{{'NAVBAR.FACILITIES' | translate}}</span>
        <hr class="soc-panel-line"/>
    </div>
    <div class="d-flex justify-content-between">
        <span class="soc-h4">{{'INVENTORY.INVENTORY' | translate}}</span>
        <button *ngIf="inventories?.length != 0" class="soc-basic-cyan-btn" (click)="addNewInventory()"><span class="material-icons">inventory</span>{{'INVENTORY.NEW' | translate}}</button>
    </div> 
    <hr class="soc-panel-line"/>

    <div *ngIf="inventories?.length == 0 && !spinner" class="pos-no-entities-wrapper">
        <div class="pos-no-entities-indicator">
            <span class="material-icons pos-no-entities-icon">inventory</span>
            <span class="soc-h2 text-center">{{'INVENTORY.NO_INVENTORY' | translate}}</span>
            <span class="soc-p text-center">{{'INVENTORY.CREATE_INVENTORY_TEXT' | translate}}</span>
            <button class="soc-basic-cyan-btn" (click)="addNewInventory()">{{'INVENTORY.CREATE_INVENTORY' | translate}}</button>
        </div>
    </div>
    <div *ngIf="spinner" style="display: flex; justify-content: center; align-items: center; height: calc(100vh - 462px);">
        <p-progressSpinner strokeWidth="4"></p-progressSpinner>
    </div> 
    <div *ngIf="inventories?.length != 0" class="pos-panel-cards-wrapper">
        <ng-container *ngFor="let inventory of inventories"> 
        <div class="soc-card" (click)="openInventory(inventory)">
                <span class="material-icons soc-img-placeholder">inventory</span>
                <div class="soc-card-info">
                    <div class="d-flex justify-content-between w-100">
                        <div class="soc-card-title">
                            <span class="soc-h2">{{inventory.name}}</span>
                            <span *ngIf="inventory.isMain" class="soc-pill-lbl soc-magenta-pill-outline"><img height="16px" width="16px" src="assets/icons/crown-icon.svg">{{'INVENTORY.MAIN' | translate}}</span>
                        </div>
                        <span class="material-icons neutral-90" (click)="$event.stopPropagation(); actionMenu.toggle($event)">more_vert</span>
                        <p-overlayPanel #actionMenu [dismissable]="true" class="d-none">
                            <div class="soc-action-menu-content">
                                <div class="soc-action-item" (click)="editInventory(inventory)">{{'INVENTORY.EDIT' | translate}}</div>
                                <div class="soc-action-item" (click)="deleteInventory(inventory)">{{'INVENTORY.DELETE' | translate}}</div>
                            </div>
                        </p-overlayPanel>
                    </div>
                    <div class="soc-wrapper-gap-12-column w-100">
                        <div class="soc-card-subtitle">
                            <span class="soc-display-lbl w-100">{{'INVENTORY.MANAGERS' | translate}}</span>  
                            <span class="soc-text soc-cyan-color w-100 text-end"> {{inventory.managers?.length}} {{'INVENTORY.MANAGERS_ASSIGNED' | translate}}</span>  
                        </div>
                        <hr class="soc-split-line">
                        <div class="soc-card-content align-items-center">
                            <ng-container *ngFor="let manager of inventory.managers">
                                <span>{{manager.firstName}} {{manager.lastName}}</span>
                                <i class="pi pi-circle-fill soc-numbering-dot" style="padding-right: 4px;padding-left: 4px;"></i>
                            </ng-container>
                        </div>
                    </div>
                </div>
        </div> 
        </ng-container>  
    </div>

</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
<p-toast position="top-center"></p-toast>
 